import { render, staticRenderFns } from "./ColumnDetail.vue?vue&type=template&id=1841bfe2&scoped=true&"
import script from "./ColumnDetail.vue?vue&type=script&lang=js&"
export * from "./ColumnDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841bfe2",
  null
  
)

export default component.exports